<template>
  <div>
    <JcdcLoadingPage v-if="$store.state.evaluations.loadingPage" />
    <div v-else>
      <JcdcTabs>
        <v-tab
          v-for="(item, index) in tabItems"
          :key="index"
          :to="{ name: item }"
          active-class="primary white--text"
          style="text-transform: none"
        >
          {{ item }}
        </v-tab>
        <v-tabs-items>
          <v-card flat>
            <v-card-text>
              <router-view />
            </v-card-text>
          </v-card>
        </v-tabs-items>
      </JcdcTabs>
    </div>
  </div>
</template>
<script>
// JCDC Components
import { JcdcLoadingPage, JcdcTabs } from '@/components/jcdc/index'

export default {
  name: 'EvaluationsPage',
  components: {
    JcdcTabs,
    JcdcLoadingPage,
  },
  data() {
    return {
      tabItems: ['Evaluations ', 'Goals', 'Strengths/Barriers'],
    }
  },
}
</script>
